"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquadsEmbeddedWalletAdapter = exports.ParentWindowName = exports.EmbeddedWalletName = void 0;
const wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
const web3_js_1 = require("@solana/web3.js");
const messageBus_1 = require("./messageBus");
exports.EmbeddedWalletName = "Squads Multisig";
exports.ParentWindowName = "squads-custom-app";
class SquadsEmbeddedWalletAdapter extends wallet_adapter_base_1.BaseWalletAdapter {
    constructor(targetOrigin = "https://v3.squads.so/") {
        super();
        this.name = exports.EmbeddedWalletName;
        this.url = "https://v3.squads.so";
        this.icon = "data:image/svg+xml;base64,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";
        this.supportedTransactionVersions = null;
        this._readyState = typeof window === "undefined" || typeof document === "undefined"
            ? wallet_adapter_base_1.WalletReadyState.Unsupported
            : wallet_adapter_base_1.WalletReadyState.NotDetected;
        this._connecting = false;
        this._publicKey = null;
        this._messageBus = null;
        this._targetOrigin = targetOrigin;
        if (this._readyState !== wallet_adapter_base_1.WalletReadyState.Unsupported) {
            (0, wallet_adapter_base_1.scopePollingDetectionStrategy)(() => {
                if (self !== top) {
                    this._readyState = wallet_adapter_base_1.WalletReadyState.Installed;
                    this._messageBus = new messageBus_1.MessageBus(window.parent, this._targetOrigin);
                    this._messageBus.connect();
                    this.emit("readyStateChange", this._readyState);
                    return true;
                }
                return false;
            });
        }
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get connected() {
        return !!this.publicKey;
    }
    get readyState() {
        return this._readyState;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("wallet connect called");
            try {
                if (this.connected || this.connecting)
                    return;
                if (this._readyState !== wallet_adapter_base_1.WalletReadyState.Loadable &&
                    this._readyState !== wallet_adapter_base_1.WalletReadyState.Installed)
                    throw new wallet_adapter_base_1.WalletNotReadyError();
                if (!this._messageBus)
                    throw new wallet_adapter_base_1.WalletNotReadyError();
                this._connecting = true;
                const vaultInfo = yield this._messageBus.sendRequest(`getVaultInfo#${Date.now()}`, "getVaultInfo");
                console.log("Received request for vault info");
                // NOTE: Here we assume that the first vault returned should be connected
                this._publicKey = new web3_js_1.PublicKey(vaultInfo[0].pubkey);
                this.emit("connect", this._publicKey);
            }
            catch (error) {
                console.log(error);
                this.emit("error", error);
                throw error;
            }
            finally {
                this._connecting = false;
            }
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this._publicKey = null;
            this.emit("disconnect");
        });
    }
    signTransaction(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                throw new wallet_adapter_base_1.WalletNotConnectedError();
            if (!this._messageBus)
                throw new wallet_adapter_base_1.WalletNotReadyError();
            return yield this._messageBus.sendRequest(`proposeTransaction#${Date.now()}`, "proposeTransaction", {
                instructions: tx.instructions.map((instr) => ({
                    keys: instr.keys.map((key) => ({
                        pubkey: key.pubkey.toString(),
                        isSigner: key.isSigner,
                        isWritable: key.isWritable,
                    })),
                    data: instr.data.toJSON(),
                    programId: instr.programId.toString(),
                })),
                type: "string"
            });
        });
    }
    signAllTransactions(txs) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                throw new wallet_adapter_base_1.WalletNotConnectedError();
            if (!this._messageBus)
                throw new wallet_adapter_base_1.WalletNotReadyError();
            const instructions = [];
            txs.forEach((tx) => tx.instructions.forEach((instr) => {
                instructions.push({
                    keys: instr.keys.map((key) => ({
                        pubkey: key.pubkey.toString(),
                        isSigner: key.isSigner,
                        isWritable: key.isWritable,
                    })),
                    data: instr.data.toJSON(),
                    programId: instr.programId.toString(),
                });
            }));
            return yield this._messageBus.sendRequest(`proposeTransaction#${Date.now()}`, "proposeTransaction", {
                instructions: instructions,
                type: "array"
            });
        });
    }
    sendAll(txWithSigners, _opts) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                throw new wallet_adapter_base_1.WalletNotConnectedError();
            if (!this._messageBus)
                throw new wallet_adapter_base_1.WalletNotReadyError();
            const instructions = [];
            txWithSigners.forEach((tx) => tx.tx.instructions.forEach((instr) => {
                instructions.push({
                    keys: instr.keys.map((key) => ({
                        pubkey: key.pubkey.toString(),
                        isSigner: key.isSigner,
                        isWritable: key.isWritable,
                    })),
                    data: instr.data.toJSON(),
                    programId: instr.programId.toString(),
                });
            }));
            return yield this._messageBus.sendRequest(`proposeTransaction#${Date.now()}`, "proposeTransaction", {
                instructions: instructions,
                type: "array"
            });
        });
    }
    sendAndConfirm(tx, _signers, _opts) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                throw new wallet_adapter_base_1.WalletNotConnectedError();
            if (!this._messageBus)
                throw new wallet_adapter_base_1.WalletNotReadyError();
            return yield this._messageBus.sendRequest(`proposeTransaction#${Date.now()}`, "proposeTransaction", {
                instructions: tx.instructions.map((instr) => ({
                    keys: instr.keys.map((key) => ({
                        pubkey: key.pubkey.toString(),
                        isSigner: key.isSigner,
                        isWritable: key.isWritable,
                    })),
                    data: instr.data.toJSON(),
                    programId: instr.programId.toString(),
                })),
                type: "string"
            });
        });
    }
    sendTransaction(transaction, _connection, _options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                throw new wallet_adapter_base_1.WalletNotConnectedError();
            if (!this._messageBus)
                throw new wallet_adapter_base_1.WalletNotReadyError();
            return yield this._messageBus.sendRequest(`proposeTransaction#${Date.now()}`, "proposeTransaction", {
                instructions: transaction.instructions.map((instr) => ({
                    keys: instr.keys.map((key) => ({
                        pubkey: key.pubkey.toString(),
                        isSigner: key.isSigner,
                        isWritable: key.isWritable,
                    })),
                    data: instr.data.toJSON(),
                    programId: instr.programId.toString(),
                })),
                type: "string"
            });
        });
    }
}
exports.SquadsEmbeddedWalletAdapter = SquadsEmbeddedWalletAdapter;
